import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {Row, Col} from 'reactstrap';
import {blank, mapWithIndex} from '@/util';
import styles from '@/b2b/index.module.css';
import {SystemConfigCtx} from '@/contexts';

const LegendList = () => {
  const {t: tr} = useTranslation('nb');
  const {siteCode} = useContext(SystemConfigCtx);
  const {siteShortName} = useContext(SystemConfigCtx);

  const items = [
    {
      stageName: tr('stage_1'),
      description: tr('stage_1_desc', {siteShortName}),
    },
    {
      stageName: tr('stage_2'),
      description: tr('stage_2_desc', {siteShortName}),
    },
    {stageName: tr('stage_3'), description: tr('stage_3_desc')},
    {stageName: tr('stage_4'), description: tr('stage_4_desc')},
    {stageName: tr('stage_5'), description: tr('stage_5_desc')},
    {
      stageName: tr('stage_6'),
      description: tr('stage_6_desc', {siteShortName}),
    },
    {stageName: tr('stage_7'), description: tr('stage_7_desc')},
    {stageName: tr('stage_other'), description: tr('stage_other_desc')},
  ];

  const itemList = mapWithIndex((item, idx) => (
    <Row key={idx}>
      <Col md='1'>
        <span className='badge badge-success'>{item.stageName}</span>
      </Col>
      <Col md='10'>{item.description}</Col>
    </Row>
  ))(items);

  if (blank(siteCode)) {
    return null;
  }

  return (
    <>
      {siteCode !== 'absg' && (
        <div className={styles.legend_box}>
          <span className={styles.legend}>{tr('legend')}</span>
          {itemList}
        </div>
      )}
    </>
  );
};

const SortLabelHint = () => {
  const {t: tr} = useTranslation();
  return <strong>* {tr('sortable_column')}</strong>;
};

export {LegendList, SortLabelHint};
